import MissionVision from "../components/MissionVision.js";
import Values from "../components/Values.js";
import Footer from "../components/Footer.js";

export default function AboutPage() {
  return (
    <>
      <MissionVision />
      <Values />
      <Footer />
    </>
  );
}